import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { AddPaymentCardForm } from '@/features/consumer/add-payment-card-form';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/my-wallet/add-payment-card'
)({
  component: AddPaymentCardPage,
});

function AddPaymentCardPage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/my-wallet' })}
        />
        <HeaderDashboard.Title>Add Payment Card</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <AddPaymentCardForm />
      </div>
    </div>
  );
}
